import React from "react";
import "./Backdrop.css";
const BackDrop: React.FC<{ onClick: any }> = (props) => {
  return <div className="backdrop" onClick={props.onClick}></div>;
};
export default BackDrop;
